import { Box, styled } from "@mui/material";

export const LiveDataWrapper = styled(Box)(() => ({
	display: "flex",
	flexDirection: "row",
	gap: "10px",
	justifyContent: "center",
	alignItems: "center",
	width: "calc(100% - 32px)",
	padding: "10px",
	margin: "5px",
	borderRadius: "10px",
	backgroundColor: "#fff",
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
	border: "1px solid #e0e0e0",
}));

export const LiveDataTile = styled(Box)(() => ({
	display: "flex",
	flexDirection: "column",
	gap: "5px",
	justifyContent: "center",
	alignItems: "center",
	width: "100%",
	padding: "10px",
	borderRadius: "10px",
	backgroundColor: "#fff",
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
	border: "1px solid #e0e0e0",
}));

export const SliderWrapper = styled(Box)(() => ({
	display: "flex",
	flexDirection: "row",
	gap: "10px",
	justifyContent: "center",
	alignItems: "center",
	width: "calc(100% - 32px)",
	padding: "2px 10px",
	margin: "5px",
	borderRadius: "10px",
	backgroundColor: "#fff",
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
	border: "1px solid #e0e0e0",
}));

// #dashboard-container {
// 	display: grid;
// 	grid-template-columns: 1fr 1fr;
// 	grid-template-rows: 1fr 1fr;
// 	gap: 15px;
// }

export const HistoricalDataWrapper = styled(Box)(() => ({
	display: "grid",
	gridTemplateColumns: "1fr 1fr",
	gridTemplateRows: "1fr 1fr",
	gap: "5px",
	height: "100%",
	// height: "75vh",
	// height: "auto",
	width: "calc(100% - 10px)",
	// width: "100%",
	// marginLeft: "5px",
	margin: "0px 0px 5px 5px",
}));

// .chart-wrapper {
// 	width: 100%;
// 	height: 42vh;
// 	border: 1px solid #ccc;
// 	padding: 10px;
// 	box-sizing: border-box;
// }

export const HistoricalChart = styled(Box)(() => ({
	// width: "100%",
	// width: "calc(100% - 1px)",
	width: "auto",
	height: "auto",
	// height: "42vh",
	padding: "10px",
	// margin: "0px 5px 5px 0px",
	// marginRight: "5px",
	boxSizing: "border-box",
	backgroundColor: "#fff",
	borderRadius: "10px",
	boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
	border: "1px solid #e0e0e0",
}));
